/* ================================================
   D-VINE WIDGET — D-TAIL LAB v3.8
   v3.8: Session open logging — track abandoned sessions
   ================================================ */
(function () {
  // Singleton guard — prevent double-run if somehow loaded twice
  if (window.__dvineV38 || window.__dvineV39) return;
  window.__dvineV38 = true;
  window.__dvineV39 = true;

  var DVINE_API = "https://dvine-chat.misty-dust-9bc3.workers.dev/";
  var DVINE_CANARY_API = "https://chat.dtaillab.com/chat";
  var canaryMode = new URLSearchParams(window.location.search).get("dvcanary") === "v2";
  var SESSION_KEY = "dvine_" + Math.random().toString(36).substr(2, 9);
  var messages = [];
  var isOpen = false;

  function css(el, styles) { Object.assign(el.style, styles); }

  function isMobile() {
    return window.innerWidth <= 767;
  }

  function killLegacy() {
    // Remove ALL dvine elements from DOM (dvine-clean leftovers)
    var ids = ['dvine-btn','dvine-window','dvine-header','dvine-messages',
               'dvine-input-area','dvine-input','dvine-send','dvine-footer',
               'dvine-close','dvine-styles-v35'];
    ids.forEach(function(id) {
      document.querySelectorAll('#' + id).forEach(function(el) { el.remove(); });
    });
    // Kill legacy style block if any
    document.querySelectorAll('style').forEach(function(s) {
      if (s.textContent && s.textContent.indexOf('#dvine-btn') !== -1) s.remove();
    });
  }


  // ─── LEGACY dvine-clean.js CLEANUP (targeted, v37-safe) ────────────────
  // Removes ONLY the legacy widget injected by the old Shopify ScriptTag
  // (1c707317a_dvine-clean.js). Never touches the official v37 elements.
  var LEGACY_DVINE_IDS = ['dvine-btn','dvine-window','dvine-header','dvine-messages',
                          'dvine-input-area','dvine-input','dvine-send','dvine-footer',
                          'dvine-close'];

  function isLegacyDvineStyle(s) {
    if (!s || s.tagName !== 'STYLE' || !s.textContent) return false;
    var t = s.textContent;
    // Never match the official v37 stylesheet
    if (t.indexOf('#dvine-btn-v37') !== -1 || t.indexOf('#dvine-window-v37') !== -1) return false;
    // Exact legacy selectors only (with brace, so -v37 ids can never match)
    return t.indexOf('#dvine-btn{') !== -1 || t.indexOf('#dvine-window{') !== -1;
  }

  function removeLegacyDvine() {
    LEGACY_DVINE_IDS.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.remove();
    });
    var styles = document.querySelectorAll('style');
    for (var si = 0; si < styles.length; si++) {
      if (isLegacyDvineStyle(styles[si])) styles[si].remove();
    }
  }

  function watchForLegacyDvine() {
    // Immediate cleanup of any legacy widget already present
    removeLegacyDvine();
    // Targeted observer: inspect ONLY newly added nodes; no full-DOM rescans
    var obs = new MutationObserver(function(muts) {
      for (var i = 0; i < muts.length; i++) {
        var nodes = muts[i].addedNodes;
        for (var j = 0; j < nodes.length; j++) {
          var n = nodes[j];
          if (n.nodeType !== 1) continue;
          if (isLegacyDvineStyle(n)) { n.remove(); continue; }
          var hit = false;
          if (n.id && LEGACY_DVINE_IDS.indexOf(n.id) !== -1) {
            hit = true;
          } else if (n.querySelector) {
            for (var k = 0; k < LEGACY_DVINE_IDS.length; k++) {
              if (n.querySelector('#' + LEGACY_DVINE_IDS[k])) { hit = true; break; }
            }
          }
          if (hit) removeLegacyDvine();
        }
      }
    });
    // documentElement subtree covers body (legacy elements) AND head (legacy <style>)
    obs.observe(document.documentElement, { childList: true, subtree: true });
    // Legacy ScriptTag injects around window load; watch 12s past load, then stop
    var stopWatching = function() {
      setTimeout(function() { obs.disconnect(); }, 12000);
    };
    if (document.readyState === 'complete') stopWatching();
    else window.addEventListener('load', stopWatching);
  }

  function injectStyles() {
    var s = document.createElement("style");
    s.id = "dvine-styles-v37";
    s.textContent = [
      "@keyframes dvine-bounce{0%,80%,100%{transform:scale(0.5);opacity:0.4;}40%{transform:scale(1);opacity:1;}}",
      ".dvine-typing span{animation:dvine-bounce 1s infinite;}",
      ".dvine-typing span:nth-child(2){animation-delay:0.2s;}",
      ".dvine-typing span:nth-child(3){animation-delay:0.4s;}",
      "#dvine-btn-v37:hover{transform:scale(1.08) !important;box-shadow:0 6px 28px rgba(204,0,0,0.7) !important;}",
      ".dvine-msg a{color:#3a86ff !important;text-decoration:underline !important;}",
      "#dvine-input-v37::placeholder{color:#666 !important;}",
      /* ---- MOBILE OVERRIDES: scoped strictly to #dvine-window-v37 ---- */
      "@media (max-width: 767px) {",
      "  #dvine-window-v37 {",
      "    width: calc(100vw - 24px) !important;",
      "    max-width: calc(100vw - 24px) !important;",
      "    right: 12px !important;",
      "    left: 12px !important;",
      "    bottom: calc(80px + env(safe-area-inset-bottom, 0px)) !important;",
      "    max-height: min(75dvh, 580px) !important;",
      "    height: auto !important;",
      "    box-sizing: border-box !important;",
      "  }",
      "  #dvine-window-v37 #dvine-msgarea-v37 {",
      "    overflow-y: auto !important;",
      "    min-height: 0 !important;",
      "    -webkit-overflow-scrolling: touch;",
      "  }",
      "  #dvine-window-v37 #dvine-inputarea-v37 {",
      "    width: 100% !important;",
      "    box-sizing: border-box !important;",
      "    gap: 8px !important;",
      "  }",
      "  #dvine-input-v37 {",
      "    width: 100% !important;",
      "    max-width: 100% !important;",
      "    min-width: 0 !important;",
      "    min-height: 42px !important;",
      "    max-height: 110px !important;",
      "    font-size: 16px !important;",
      "    line-height: 1.35 !important;",
      "    box-sizing: border-box !important;",
      "    resize: none !important;",
      "  }",
      "  #dvine-sendbtn-v37 {",
      "    flex: 0 0 auto !important;",
      "    width: 42px !important;",
      "    height: 42px !important;",
      "  }",
      "}"
    ].join("\n");
    document.head.appendChild(s);
  }

  function renderMarkdown(text) {
    if (!text) return "";
    var html = String(text), links = [];
    html = html.replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g, function(m, label, url) {
      links.push({label: label, url: url});
      return "%%LINK" + (links.length - 1) + "%%";
    });
    html = html.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");
    html = html.replace(/%%LINK(\d+)%%/g, function(m, i) {
      var l = links[+i];
      return '<a href="'+l.url+'" target="_blank" rel="noopener">'+l.label+'</a>';
    });
    html = html.replace(/(^|[\s\n])(https?:\/\/[^\s<"]+)/g, function(m, pre, url) {
      return pre+'<a href="'+url+'" target="_blank" rel="noopener">'+url+'</a>';
    });
    html = html.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    html = html.replace(/\n/g, "<br>");
    return html;
  }

  function build() {
    killLegacy();
    injectStyles();

    var mobile = isMobile();
    var mobileHome = mobile && /^\/(?:[a-z]{2}(?:-[a-z]{2})?)?\/?$/i.test(window.location.pathname);

    // ---- BUTTON ----
    var btn = document.createElement("button");
    btn.id = "dvine-btn-v37";
    btn.setAttribute("aria-label", "Open D-Vine chat");
    css(btn, {
      position:"fixed", bottom: mobileHome ? "calc(88px + env(safe-area-inset-bottom, 0px))" : "24px", right:"24px", zIndex:"2147483647",
      width:"60px", height:"60px", borderRadius:"50%",
      background:"#CC0000", border:"none", cursor:"pointer",
      boxShadow:"0 4px 20px rgba(204,0,0,0.5)",
      display:"flex", alignItems:"center", justifyContent:"center",
      transition:"transform 0.2s,box-shadow 0.2s",
      padding:"0", margin:"0", outline:"none"
    });
    btn.innerHTML = '<img src="https://media.base44.com/images/public/69cd59548ab42ae561b495bc/5a2793839_generated_image.png" alt="" style="width:36px;height:36px;border-radius:50%;object-fit:cover;pointer-events:none;display:block;" />';

    // ---- WINDOW ----
    var win = document.createElement("div");
    win.id = "dvine-window-v37";
    css(win, {
      position:"fixed",
      bottom: mobileHome ? "calc(160px + env(safe-area-inset-bottom, 0px))" : mobile ? "calc(80px + env(safe-area-inset-bottom, 0px))" : "96px",
      right: mobile ? "12px" : "24px",
      left: mobile ? "12px" : "auto",
      zIndex:"2147483646",
      width: mobile ? "calc(100vw - 24px)" : "360px",
      maxWidth: mobile ? "calc(100vw - 24px)" : "360px",
      height: mobile ? "auto" : "520px",
      maxHeight: mobile ? "min(75dvh, 580px)" : "520px",
      background:"#0a0a0a",
      borderRadius:"16px", border:"1px solid #CC0000",
      flexDirection:"column", overflow:"hidden",
      boxShadow:"0 8px 40px rgba(0,0,0,0.6)",
      fontFamily:"-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif",
      fontSize:"14px", display:"none", boxSizing:"border-box"
    });

    // ---- HEADER ----
    var header = document.createElement("div");
    css(header, {
      background:"#CC0000", padding:"12px 14px",
      display:"flex", alignItems:"center", gap:"10px", flexShrink:"0"
    });
    header.innerHTML = '<img src="https://media.base44.com/images/public/69cd59548ab42ae561b495bc/5a2793839_generated_image.png" alt="" style="width:36px;height:36px;border-radius:50%;object-fit:cover;" />'
      + '<div><p style="margin:0;color:#fff;font-size:14px;font-weight:700;line-height:1.3;">D-Vine — D-TAIL LAB</p>'
      + '<p style="margin:0;color:rgba(255,255,255,0.8);font-size:11px;">Assistant AI • 24/7</p></div>';

    var closeBtn = document.createElement("button");
    css(closeBtn, {
      background:"none", border:"none", color:"#fff", fontSize:"22px",
      cursor:"pointer", lineHeight:"1", padding:"0 4px", marginLeft:"auto", outline:"none"
    });
    closeBtn.textContent = "×";
    closeBtn.setAttribute("aria-label", "Close chat");
    header.appendChild(closeBtn);

    // ---- MESSAGES ----
    var msgArea = document.createElement("div");
    msgArea.id = "dvine-msgarea-v37";
    css(msgArea, {
      flex:"1", overflowY:"auto", padding:"16px",
      display:"flex", flexDirection:"column", gap:"10px",
      background:"#0a0a0a", boxSizing:"border-box",
      minHeight:"0",
      WebkitOverflowScrolling:"touch"
    });

    // ---- INPUT AREA ----
    var inputArea = document.createElement("div");
    inputArea.id = "dvine-inputarea-v37";
    css(inputArea, {
      padding:"10px", borderTop:"1px solid #1f1f1f",
      display:"flex", gap:"8px", alignItems:"center", flexShrink:"0",
      background:"#0a0a0a", boxSizing:"border-box", width:"100%"
    });

    var textarea = document.createElement("textarea");
    textarea.id = "dvine-input-v37";
    textarea.rows = 1;
    textarea.placeholder = "Posez votre question...";
    css(textarea, {
      flex:"1", background:"#1a1a1a", border:"1px solid #333",
      borderRadius:"8px", padding:"8px 12px", color:"#fff",
      fontSize: mobile ? "16px" : "13px",   // 16px prevents iOS auto-zoom
      outline:"none", resize:"none",
      fontFamily:"inherit", lineHeight:"1.4", boxSizing:"border-box",
      minWidth:"0",
      maxHeight: mobile ? "110px" : "80px"
    });

    var sendBtn = document.createElement("button");
    sendBtn.id = "dvine-sendbtn-v37";
    css(sendBtn, {
      width: mobile ? "42px" : "38px",
      height: mobile ? "42px" : "38px",
      background:"#CC0000", border:"none",
      borderRadius:"8px", cursor:"pointer", display:"flex",
      alignItems:"center", justifyContent:"center",
      flexShrink:"0", outline:"none"
    });
    sendBtn.innerHTML = '<svg viewBox="0 0 24 24" style="width:18px;height:18px;fill:#fff;pointer-events:none;display:block;"><path d="M2 21l21-9L2 3v7l15 2-15 2v7z"/></svg>';
    sendBtn.setAttribute("aria-label", "Send");

    var footer = document.createElement("p");
    css(footer, {
      padding:"6px 0", margin:"0", textAlign:"center", color:"#444",
      fontSize:"10px", flexShrink:"0", background:"#0a0a0a"
    });
    footer.textContent = "Powered by D-TAIL LAB AI";

    inputArea.appendChild(textarea);
    inputArea.appendChild(sendBtn);
    win.appendChild(header);
    win.appendChild(msgArea);
    win.appendChild(inputArea);
    win.appendChild(footer);

    document.body.appendChild(btn);
    document.body.appendChild(win);

    // ---- MESSAGE HELPERS ----
    function addMsg(role, text) {
      var el = document.createElement("div");
      el.className = "dvine-msg " + role;
      css(el, {
        maxWidth:"82%", padding:"10px 14px", fontSize:"13px", lineHeight:"1.6",
        wordWrap:"break-word", overflowWrap:"break-word", wordBreak:"break-word",
        borderRadius: role === "bot" ? "12px 12px 12px 2px" : "12px 12px 2px 12px",
        background: role === "bot" ? "#1a1a1a" : "#CC0000",
        color: role === "bot" ? "#f0f0f0" : "#fff",
        alignSelf: role === "bot" ? "flex-start" : "flex-end",
        border: role === "bot" ? "1px solid #2a2a2a" : "none"
      });
      if (role === "bot") { el.innerHTML = renderMarkdown(text); }
      else { el.textContent = text; }
      msgArea.appendChild(el);
      setTimeout(function(){ msgArea.scrollTop = msgArea.scrollHeight; }, 50);
    }

    function showTyping() {
      var el = document.createElement("div");
      el.id = "dvine-typing-v37";
      el.className = "dvine-msg bot dvine-typing";
      css(el, {
        display:"flex", gap:"4px", alignItems:"center",
        padding:"10px 14px", background:"#1a1a1a",
        border:"1px solid #2a2a2a", borderRadius:"12px 12px 12px 2px", alignSelf:"flex-start"
      });
      el.innerHTML = '<span style="width:7px;height:7px;border-radius:50%;background:#CC0000;display:inline-block;"></span>'
        +'<span style="width:7px;height:7px;border-radius:50%;background:#CC0000;display:inline-block;"></span>'
        +'<span style="width:7px;height:7px;border-radius:50%;background:#CC0000;display:inline-block;"></span>';
      msgArea.appendChild(el);
      setTimeout(function(){ msgArea.scrollTop = msgArea.scrollHeight; }, 50);
    }

    function hideTyping() {
      var t = document.getElementById("dvine-typing-v37");
      if (t) t.remove();
    }

    function shadowMirror(text, v1Reply) {
      if (canaryMode || !text || !v1Reply) return;

      var lang = navigator.language && navigator.language.toLowerCase().startsWith("fr") ? "fr"
        : navigator.language && navigator.language.toLowerCase().startsWith("es") ? "es" : "en";

      var prior = messages.slice(-12).map(function(m) {
        return { role: m.role, content: m.content };
      });

      fetch("https://chat.dtaillab.com/shadow", {
        method: "POST",
        credentials: "omit",
        keepalive: true,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: text,
          session_id: SESSION_KEY,
          v1_reply: v1Reply,
          messages: prior,
          lang_hint: lang
        })
      }).catch(function() {});
    }

    function v1Send(text) {
      fetch(DVINE_API, {
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body: JSON.stringify({
          message: text, session_id: SESSION_KEY,
          messages: messages, source_url: window.location.href
        })
      })
      .then(function(r){ return r.json(); })
      .then(function(d){
        hideTyping();
        addMsg("bot", d.reply || "Sorry, something went wrong.");
        if (!canaryMode) shadowMirror(text, d.reply || "");
        messages.push({role:"user", content:text});
        messages.push({role:"assistant", content:d.reply});
      })
      .catch(function(){
        hideTyping();
        addMsg("bot", "Une erreur est survenue. Veuillez réessayer.");
      });
    }

    function send() {
      var text = textarea.value.trim();
      if (!text) return;
      textarea.value = "";
      textarea.style.height = "auto";
      addMsg("user", text);
      showTyping();
      if (!canaryMode) { v1Send(text); return; }
      // ── D-Vine V2 staff canary (server-authoritative; URL param never grants access) ──
      fetch(DVINE_CANARY_API, {
        method:"POST",
        credentials:"include",
        headers:{"Content-Type":"application/json"},
        body: JSON.stringify({
          message: text, session_id: SESSION_KEY,
          messages: messages, source_url: window.location.href,
          canary_request: true,
          canary_id: "c_" + Date.now() + "_" + Math.random().toString(36).substr(2, 8)
        })
      })
      .then(function(r){
        if (!r.ok) throw new Error("canary_refused_" + r.status);
        return r.json();
      })
      .then(function(d){
        if (!d || !d.reply) throw new Error("canary_no_reply");
        hideTyping();
        addMsg("bot", d.reply);
        messages.push({role:"user", content:text});
        messages.push({role:"assistant", content:d.reply});
      })
      .catch(function(){
        // canary refused or unavailable → byte-identical V1 fallback (one engine only)
        v1Send(text);
      });
    }

    // ---- EVENTS ----
    var sessionOpenSent = false;

    btn.addEventListener("click", function() {
      isOpen = !isOpen;
      if (isOpen) {
        win.style.display = "flex";
        if (msgArea.children.length === 0) {
          var fr = navigator.language && navigator.language.toLowerCase().startsWith("fr");
          addMsg("bot", fr
            ? "Bonjour! Je suis D-Vine, votre assistant D-TAIL LAB. Comment puis-je vous aider? 🔴"
            : "Hello! I'm D-Vine, your D-TAIL LAB assistant. How can I help you today? 🔴"
          );
        }
        textarea.focus();
        // Log session open (once per session) — tracks abandoned sessions
        if (!sessionOpenSent) {
          sessionOpenSent = true;
          var lang = navigator.language && navigator.language.toLowerCase().startsWith("fr") ? "fr"
            : navigator.language && navigator.language.toLowerCase().startsWith("es") ? "es" : "en";
          fetch(DVINE_API, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              _session_open: true,
              session_id: SESSION_KEY,
              language: lang,
              source_url: window.location.href,
              source_page: window.location.href
            })
          }).catch(function() {});
        }
      } else {
        win.style.display = "none";
      }
    });

    closeBtn.addEventListener("click", function() {
      isOpen = false;
      win.style.display = "none";
    });

    sendBtn.addEventListener("click", send);

    textarea.addEventListener("keydown", function(e) {
      if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); }
    });

    textarea.addEventListener("input", function() {
      this.style.height = "auto";
      var maxH = isMobile() ? 110 : 80;
      this.style.height = Math.min(this.scrollHeight, maxH) + "px";
    });

    // Targeted legacy cleanup + short-lived observer (v37-safe)
    watchForLegacyDvine();
  }

  // Run on 'load' — fires after ALL scripts (including dvine-clean.js) have executed
  window.addEventListener("load", build);

})();
